import { Carousel2 } from '@intigral/ui';
import { SectionHeaderWithPagination } from '@intigral/ui/components/SectionHeaderWithPagination';
import { useRef } from 'react';
import h from '../../../../helpers/common';
import { __ } from '../../../../translations';
import { getSwiperSettings } from '../helper';
import { Mood } from '@intigral/shared';
import useLanguage from '../../../../hooks/useLanguage';

const CarouselWrapper = ({ title = '', onChangeMood = undefined, children, isLoading = false, slidesPerView = 4 }) => {
    const language = useLanguage();
    const swiperElement = useRef(null);

    return (
        <div className="container full-width">
            {title && (
                <SectionHeaderWithPagination
                    title={title}
                    className="paging"
                    onClick={onChangeMood || undefined}
                    seeAllText={onChangeMood ? __('moods_change_mood_text') : undefined}
                    seeAllUrl={onChangeMood ? '#' : undefined}
                    isLoading={isLoading}
                />
            )}
            <Carousel2
                swiperSettings={getSwiperSettings(language, slidesPerView)}
                ref={swiperElement}
                isLoading={isLoading}
                data-test-id="moods-carousel"
            >
                {isLoading ? <Mood data-test-id="moods-carousel-loading" isLoading={isLoading} /> : children}
            </Carousel2>
        </div>
    );
};

export default CarouselWrapper;
